export default "__VITE_ASSET__BwSA_98j__"